module.exports = __webpack_public_path__ + "static/media/wallpaper.1dc3a253.png";